import Phaser from "phaser";

const DEPTH_FLOOR = 40;
const DEPTH_LIGHT = 70_000;

export class DungeonAtmosphere {
  private readonly embers: Phaser.GameObjects.Arc[] = [];
  private readonly runes: Phaser.GameObjects.Container[] = [];

  constructor(private readonly scene: Phaser.Scene) {
    this.createVignette();
    this.createArenaRings();
    this.createTorches();
    this.createRunes();
    this.createEmbers();
  }

  update(): void {
    const t = this.scene.time.now;
    this.embers.forEach((ember, i) => {
      ember.y -= 0.12 + (i % 4) * 0.025;
      ember.x += Math.sin(t / 650 + i) * 0.08;
      if (ember.y < 120) ember.y = 1020;
    });
  }

  createImpact(x: number, y: number, color = 0x8b4cff): void {
    const ring = this.scene.add.circle(x, y, 22, color, 0.08)
      .setStrokeStyle(4, color, 0.95).setDepth(80_000);
    const flash = this.scene.add.circle(x, y, 8, 0xffffff, 0.9).setDepth(80_001);
    this.scene.tweens.add({ targets: ring, radius: 86, alpha: 0, duration: 420, ease: "Cubic.Out", onComplete: () => ring.destroy() });
    this.scene.tweens.add({ targets: flash, radius: 44, alpha: 0, duration: 240, onComplete: () => flash.destroy() });
  }

  private createVignette(): void {
    const g = this.scene.add.graphics().setScrollFactor(0).setDepth(DEPTH_LIGHT);
    for (let i = 0; i < 18; i += 1) {
      const alpha = 0.018 + i * 0.006;
      g.lineStyle(38, 0x000000, alpha);
      g.strokeRect(0 + i * 10, 0 + i * 6, 1920 - i * 20, 1080 - i * 12);
    }
    this.scene.add.rectangle(960, 540, 1920, 1080, 0x160b04, 0.08).setScrollFactor(0).setDepth(DEPTH_LIGHT - 1);
  }

  private createArenaRings(): void {
    const g = this.scene.add.graphics().setDepth(DEPTH_FLOOR);
    g.lineStyle(3, 0x8a642b, 0.35);
    g.strokeEllipse(960, 540, 1000, 610);
    g.lineStyle(2, 0x6c3db0, 0.32);
    g.strokeEllipse(960, 540, 670, 410);
    for (let i = 0; i < 32; i += 1) {
      const a = (Math.PI * 2 * i) / 32;
      const x1 = 960 + Math.cos(a) * 355;
      const y1 = 540 + Math.sin(a) * 218;
      const x2 = 960 + Math.cos(a) * 382;
      const y2 = 540 + Math.sin(a) * 234;
      g.lineStyle(i % 2 ? 2 : 4, 0xb48a42, 0.28);
      g.lineBetween(x1, y1, x2, y2);
    }
  }

  private createTorches(): void {
    const points: Array<[number, number]> = [[190,160],[440,170],[1480,170],[1730,160],[200,840],[440,880],[1480,880],[1730,840]];
    points.forEach(([x,y], index) => {
      const glow = this.scene.add.circle(x, y, 56, 0xff6a16, 0.11).setDepth(DEPTH_LIGHT - 2);
      const core = this.scene.add.ellipse(x, y, 13, 28, 0xffb12b, 0.92).setDepth(DEPTH_LIGHT - 1);
      this.scene.tweens.add({ targets: [glow, core], scaleX: {from:0.84,to:1.18}, scaleY:{from:0.9,to:1.26}, alpha:{from:0.55,to:1}, duration: 420 + index * 37, yoyo:true, repeat:-1 });
    });
  }

  private createRunes(): void {
    const points: Array<[number, number, number]> = [[510,690,0xc52c19],[1390,690,0xc52c19],[720,390,0x7a37d1],[1200,390,0x7a37d1]];
    points.forEach(([x,y,color], i) => {
      const c = this.scene.add.container(x,y).setDepth(DEPTH_FLOOR+1);
      const g = this.scene.add.graphics();
      g.lineStyle(3,color,0.55); g.strokeCircle(0,0,62); g.strokeCircle(0,0,45);
      for(let n=0;n<8;n+=1){ const a=n*Math.PI/4; g.lineBetween(Math.cos(a)*26,Math.sin(a)*26,Math.cos(a)*58,Math.sin(a)*58); }
      c.add(g); this.runes.push(c);
      this.scene.tweens.add({targets:c, angle:i%2?360:-360, duration:14000+i*800, repeat:-1});
      this.scene.tweens.add({targets:g, alpha:{from:0.25,to:0.78}, duration:900+i*120, yoyo:true, repeat:-1});
    });
  }

  private createEmbers(): void {
    for (let i = 0; i < 70; i += 1) {
      const ember = this.scene.add.circle(Phaser.Math.Between(120,1800), Phaser.Math.Between(100,1020), Phaser.Math.Between(1,3), i%5===0?0xa96cff:0xff8a26, Phaser.Math.FloatBetween(0.15,0.55)).setDepth(DEPTH_LIGHT-3);
      this.embers.push(ember);
    }
  }
}
